module.exports = __webpack_public_path__ + "img/00019.03b4445e.webp";